var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("route.BusinessUserfunConfig")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _vm.isSee
                ? [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                      [_vm._v(_vm._s(_vm.$t("backText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.showLog },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessPurchaseApplyDetail.operationLog")
                          )
                        ),
                      ]
                    ),
                  ]
                : [
                    _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleConfirm },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    ),
                  ],
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.dataInfo, rules: _vm.rules } },
        [
          !_vm.$store.getters.cusId
            ? _c(
                "div",
                { staticStyle: { width: "600px" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.CustomerName"),
                        prop: "clientCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          disabled: !!_vm.userId,
                          clearable: false,
                          "option-list": _vm.clientCodeList,
                          placeholder: _vm.$t("billingPage.CustomerName"),
                        },
                        model: {
                          value: _vm.dataInfo.clientCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInfo, "clientCode", $$v)
                          },
                          expression: "dataInfo.clientCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.dataInfo.features, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c("BjDivider", [
                  _vm._v(
                    _vm._s(
                      _vm.language === "zh"
                        ? item.featureNameCn
                        : item.featureNameEn
                    )
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "flex-align flex-wrap",
                    staticStyle: { "margin-left": "20px" },
                  },
                  _vm._l(item.options, function (jitem, jindex) {
                    return _c(
                      "div",
                      {
                        key: jindex,
                        style: jitem.lineBreak ? "width:100%" : "width:45%",
                      },
                      [
                        item.featureId == 3
                          ? _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.language === "zh"
                                    ? jitem.promptCn
                                    : jitem.promptEn
                                )
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          [
                            _c("label", {
                              attrs: { slot: "label" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.language === "zh"
                                    ? jitem.optionNameCn
                                    : jitem.optionNameEn
                                ),
                              },
                              slot: "label",
                            }),
                            jitem.describeCn
                              ? _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.language === "zh"
                                              ? jitem.describeCn
                                              : jitem.describeEn
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      staticStyle: {
                                        color: "#4d08ed",
                                        position: "relative",
                                        left: "-5px",
                                        "margin-right": "20px",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._l(
                              jitem.defaultValues,
                              function (kitem, kindex) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: kindex,
                                    attrs: { label: kitem.valueCode },
                                    model: {
                                      value: jitem.optionValue,
                                      callback: function ($$v) {
                                        _vm.$set(jitem, "optionValue", $$v)
                                      },
                                      expression: "jitem.optionValue",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.language === "zh"
                                          ? kitem.valueNameCn
                                          : kitem.valueNameEn
                                      )
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }